import { useUpdateEffect } from '@cian/react-utils';

import { useGetOffersByActivePinQuery } from '@/packages/query-state/shared/store/search-offers/v1/get-offers-by-pin/query';
import { useSearchOffersDesktopQuery } from '@/packages/query-state/shared/store/search-offers/v3/search-offers-desktop/query';
import { flatInfinityOffersSelector } from '@/packages/query-state/shared/store/search-offers/v3/search-offers-desktop/selectors';

import { useNewpageTracking } from './useNewpageTracking';

/**
 * @description
 * Обновляем событие pageview после изменения выдачи (общей и по пину)
 */
export function useUpdateAnalyticsAfterDataChange(): void {
  const trackNewpage = useNewpageTracking();

  /**
   * @description
   * Трекаем newpage для выдачи по пину
   */
  const { data: offersDataByPin, isFetching: isOffersDataByPinFetching } = useGetOffersByActivePinQuery();

  useUpdateEffect(() => {
    if (isOffersDataByPinFetching || !offersDataByPin) {
      return;
    }

    trackNewpage();
  }, [offersDataByPin, isOffersDataByPinFetching, trackNewpage]);

  /**
   * @description
   * Трекаем newpage для выдачи
   */
  const { data: offersData, isFetching: isOffersDataFetching } = useSearchOffersDesktopQuery({
    select: flatInfinityOffersSelector,
  });
  const listingUrl = offersData?.pages[0].seo.tech.fullUrl;

  useUpdateEffect(() => {
    if (isOffersDataFetching || !listingUrl) {
      return;
    }

    trackNewpage();
  }, [listingUrl, isOffersDataFetching, trackNewpage]);
}
